import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonColor, Icon, TextButton, ButtonVariant } from '../../../components';

interface BackButtonProps {
  onBack?: () => void;
}

const BackButton = ({ onBack }: BackButtonProps) => {
  const navigate = useNavigate();

  const handleOnBack = useCallback(() => {
    if (onBack) onBack();
    else navigate(-1);
  }, [onBack, navigate]);

  return (
    <TextButton
      color={ButtonColor.NEUTRAL}
      onClick={handleOnBack}
      startIcon={Icon.CHEVRON_LEFT}
      text="Back"
      variant={ButtonVariant.SOFT}
    />
  );
};

export default BackButton;
